import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SearchMethod} from "../types/SearchMethod";

interface TrackAmplitudeGlobalSearchAdvancedParams {
    searchQuery: string;
    searchMethod: SearchMethod;
    searchContext: string;
    range?: string;
    itemListId?: string;
}

export const trackAmplitudeGlobalSearchAdvanced = (params: TrackAmplitudeGlobalSearchAdvancedParams): void => {
    trackAmplitudeEvent("global_search_advanced", {
        search_query: params.searchQuery,
        search_method: params.searchMethod,
        search_context: params.searchContext,
        ...(params.range !== undefined && {range: params.range}),
        ...(params.itemListId !== undefined && {item_list_id: params.itemListId})
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SearchMethod} from "../types/SearchMethod";

interface TrackAmplitudeGlobalSearchAdvancedParams {
    searchQuery: string;
    searchMethod: SearchMethod;
    searchContext: string;
    range?: string;
    itemListId?: string;
}

export const trackAmplitudeGlobalSearchAdvanced = (params: TrackAmplitudeGlobalSearchAdvancedParams): void => {
    trackAmplitudeEvent("global_search_advanced", {
        search_query: params.searchQuery,
        search_method: params.searchMethod,
        search_context: params.searchContext,
        ...(params.range !== undefined && {range: params.range}),
        ...(params.itemListId !== undefined && {item_list_id: params.itemListId})
    });
};
